export default function (Component) {
      Component.options.__docs = "// empty (null-loader)"
    }